import { render, staticRenderFns } from "./InvestmentReportMinutes.vue?vue&type=template&id=11026a15&scoped=true"
import script from "./InvestmentReportMinutes.vue?vue&type=script&lang=js"
export * from "./InvestmentReportMinutes.vue?vue&type=script&lang=js"
import style0 from "./InvestmentReportMinutes.vue?vue&type=style&index=0&id=11026a15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11026a15",
  null
  
)

export default component.exports